import { render, staticRenderFns } from "./AddActivity.vue?vue&type=template&id=645158ea&scoped=true&"
import script from "./AddActivity.vue?vue&type=script&lang=js&"
export * from "./AddActivity.vue?vue&type=script&lang=js&"
import style0 from "./AddActivity.vue?vue&type=style&index=0&id=645158ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645158ea",
  null
  
)

export default component.exports